import { render, staticRenderFns } from "./view-comment-dialog.vue?vue&type=template&id=daf822b2&scoped=true"
import script from "./view-comment-dialog.vue?vue&type=script&lang=js"
export * from "./view-comment-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-comment-dialog.vue?vue&type=style&index=0&id=daf822b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf822b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf822b2')) {
      api.createRecord('daf822b2', component.options)
    } else {
      api.reload('daf822b2', component.options)
    }
    module.hot.accept("./view-comment-dialog.vue?vue&type=template&id=daf822b2&scoped=true", function () {
      api.rerender('daf822b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/se/view/view-comment-dialog.vue"
export default component.exports